import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function LeadPractitionerAdultCareLevel4() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    LEAD PRACTITIONER IN ADULT CARE
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    APPRENTICESHIP LEVEL 4
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Overview of the role */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Overview of the role:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Managing teams of frontline carers to look after vulnerable adults with care needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Details of standard */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Details of standard:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    The Lead Practitioner in Adult Care will guide and inspire team members or colleagues to make positive differences to someone's life when they are faced with physical, practical, social, emotional, psychological or intellectual challenges. They will have achieved a level of self-development to be recognised as a lead practitioner within the care team, contributing to, promoting and sustaining a values-based culture at an operational level. A Lead Practitioner has achieved a greater depth of knowledge and expertise of conditions or care experienced by the user of services. They will have specialist skills and knowledge in their area of responsibilities which will allow them to lead in areas such as care needs assessment, occupational therapy, physiotherapy, rehabilitation and enablement, telecare and assistive technology. They may be a coach and mentor to others or have a role in assessing performance and quality of care delivery. Lead Practitioners in Adult Care may work in residential or nursing homes, domiciliary care, day centres, a person's own home or some clinical healthcare settings. As well as covering Lead Practitioners in Adult Care this standard also covers Lead Personal Assistants who can work at this senior level, but they may only work directly for one individual who needs support and/or care services, usually within their own home.
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '25px' }}>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Care</strong> – is caring consistently and enough about individuals to make a positive difference to their lives
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Compassion</strong> – is delivering care and support with kindness, consideration, dignity, empathy and respect
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Courage</strong> – is doing the right thing for people and speaking up if the individual they support is at risk
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Communication</strong> – good communication is central to successful caring relationships and effective team working
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Competence</strong> – is applying knowledge and skills to provide high quality care and support
                    </li>
                    <li style={{ marginBottom: '0' }}>
                      <strong>Commitment</strong> – to improving the experience of people who need care and support ensuring it is person centred
                    </li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Examples of job roles include Dementia Lead, Re-ablement Worker, Physiotherapy Assistant, Occupational Therapy Assistant, Public Health Associate Worker, Keeping in Contact Worker, Community Care/Support Officer, Social Care Assessor, Care Assessment Officer, Social Services Officer, Brokerage Worker, Rehabilitation and Reablement Assistant, Independence Support Assistant, Reablement Support Workers/Officer, Telecare Assistant and Assistive Technology Co-Ordinator/Officer.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Qualifications */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Qualifications:
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '25px' }}>
                    <li>Level 4 Diploma in Adult Care.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Awarding Organisations: <strong>NCFE, TQUK.</strong>
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '15px' }}>
                      Apprentices without Level 2 English and maths will need to achieve this level prior to completion of their Apprenticeship.
                    </li>
                    <li style={{ marginBottom: '0' }}>
                      For those with an education, health and care plan or a legacy statement the apprenticeships English and maths minimum requirement is Entry Level 3 and British Sign Language qualification are an alternative to English qualifications for whom this is their primary language.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Duration */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Duration:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Typically, 18 months
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Level */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Level:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    4
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industry-specific requirements */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Industry-specific requirements
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '0' }}>
                    <li>Undertake the Disclosure and Barring Service process and provide the result.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default LeadPractitionerAdultCareLevel4;